import React, { Component } from 'react';

import {ScrollTo,SiteModifier,FadeIn,LoaderLink,Grid,Template,Window,Media,Section,Content,ModifierSection,Item} from '../_core/components';

// Models
import {Asset,Entry,Data} from '../_core/models';

// Project
import * as Project from '../components';


class Default extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	/*

		RENDER

	*/

	render() {

		let {entry} = this.props;
		if(!entry) return null;

		return (
			
			<Template modifiers={['listing']}>

				{/* Scroll to top */}
				<ScrollTo pos={0} />

				{/* Set BG */}
				<Data set={{background:'#222222'}} />
				<SiteModifier auto modifier={'dark'} demodifier={'scrolled,folio,light'} />

				{/* Template */}
				<FadeIn>
					{/* Title */}
					<div className="Template-head">
						<div className="Container">
							<h1>{ entry.title }</h1>
						</div>
					</div>

	
					<div className="Container Container--tiles">
					<Grid modifiers={['listing']}>
					<Entry id={entry.relatedEntries} render={
						(entry) => (

							<div className="Grid-item">
								<div className="Item Item--basic">
									<LoaderLink to={entry.uri} deactivate={'#nav'}>
										<div className="Item-media">
											<Media id={entry.thumbnail[0]} fluid={false}  />
										</div>
										<div className="Item-body">
											{entry.title}
										</div>
									</LoaderLink>
								</div>
							</div>

						)
					} />
					</Grid>
				</div>
			
				</FadeIn>
			</Template>
		
		);

	}
}

export default Default;



// WEBPACK FOOTER //
// ./src/js/templates/listing.js